namespace SorAraBul.Administration {
    export interface RolePermissionRow {
        RolePermissionId?: number;
        RoleId?: number;
        PermissionKey?: string;
        RoleRoleName?: string;
    }

    export namespace RolePermissionRow {
        export const idProperty = 'RolePermissionId';
        export const nameProperty = 'PermissionKey';
        export const localTextPrefix = 'Administration.RolePermission';
        export const lookupKey = 'Administration.RolePermission';

        export function getLookup(): Q.Lookup<RolePermissionRow> {
            return Q.getLookup<RolePermissionRow>('Administration.RolePermission');
        }
        export const deletePermission = 'Administration:SuperAdmin';
        export const insertPermission = 'Administration:SuperAdmin';
        export const readPermission = 'Administration:SuperAdmin';
        export const updatePermission = 'Administration:SuperAdmin';

        export declare const enum Fields {
            RolePermissionId = "RolePermissionId",
            RoleId = "RoleId",
            PermissionKey = "PermissionKey",
            RoleRoleName = "RoleRoleName"
        }
    }
}
